module.exports = __webpack_public_path__ + "media/images/cbjj/academy_registration_informations/academy_name_rules-ec0846c9312275ee48f0f43f5147b35d.svg";